import * as React from "react";

function SvgCurve3Inverted(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1600 200" {...props}><path d="M-6.6 177.6S456.1 40.3 876.2 40.3s730.3 135.1 730.3 135.1v33.5H-6.6v-31.3z" /></svg>;
}

export default SvgCurve3Inverted;